class FacetsToggle {
    constructor() {
        this.container = document.getElementById("Facet-Drawer");
        let e = document.getElementById("Facets-Toggle");
        e &&
            e.addEventListener("click", (e) => {
                e.preventDefault(), document.getElementsByTagName("body")[0].classList.add("open-cc"), this.container.classList.add("active");
            }),
            setTimeout(function () {
                window.dispatchEvent(new Event("resize.resize-select"));
            }, 10);
    }
}
class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(),
            (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
            (this.debouncedOnSubmit = debounce((e) => {
                this.onSubmitHandler(e);
            }, 500)),
            this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
            this.sectionElement = document.querySelector('.new-collection-section');
    }
    static setListeners() {
        window.addEventListener("popstate", (e) => {
            const t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
            t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1);
        });
        window.addEventListener("pagination:page-changed", () => {
            FacetFiltersForm.updateProductCount();
        });
    }
    static toggleActiveFacets(e = !0) {
        document.querySelectorAll(".js-facet-remove").forEach((t) => {
            t.classList.toggle("disabled", e);
        });
    }
    static renderPage(e, t, r = !0) {
        FacetFiltersForm.searchParamsPrev = e;
        const o = FacetFiltersForm.getSections(),
            c = document.getElementsByClassName("thb-filter-count");
        for (var n of (document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"), c)) n.classList.add("loading");
        o.forEach((r) => {
            const o = `${window.location.pathname}?section_id=${r.section}&${e}`,
                c = (e) => e.url === o;
            FacetFiltersForm.filterData.some(c) ? FacetFiltersForm.renderSectionFromCache(c, t) : FacetFiltersForm.renderSectionFromFetch(o, t);
        }),
            r && FacetFiltersForm.updateURLHash(e);
    }
    static renderSectionFromFetch(e, t) {
        fetch(e)
            .then((e) => e.text())
            .then((r) => {
                const o = r;
                (FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: o, url: e }]),
                    FacetFiltersForm.renderFilters(o, t),
                    FacetFiltersForm.renderProductGridContainer(o),
                    FacetFiltersForm.renderProductCount(o),
                    new FacetsToggle();
            });
    }
    static renderSectionFromCache(e, t) {
        const r = FacetFiltersForm.filterData.find(e).html;
        FacetFiltersForm.renderFilters(r, t), FacetFiltersForm.renderProductGridContainer(r), FacetFiltersForm.renderProductCount(r), new FacetsToggle();
    }
    static renderProductGridContainer(e) {
        document.getElementById("ProductGridContainer").innerHTML =
          new DOMParser().parseFromString(e, "text/html").getElementById("ProductGridContainer").innerHTML;
      
        // Check the flag to determine if scrolling should occur
        if (!window.skipScrollToTop) {
          const t =
            document.getElementById("ProductGridContainer").getBoundingClientRect().top +
            document.documentElement.scrollTop -
            parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10) -
            30;
          window.scrollTo({ top: t, left: 0, behavior: "smooth" });
        }
      
        // Reset the flag after handling
        window.skipScrollToTop = false;
      }

    static renderProductCount(e) {
        const t = new DOMParser().parseFromString(e, "text/html").getElementById("ProductCount"),
            r = document.getElementsByClassName("thb-filter-count");
        if (t) {
            const sectionElement = document.querySelector('.new-collection-section');
            let countHTML = t.innerHTML;
            
            if (!FacetFiltersForm.originalTotalCount && (!sectionElement || !sectionElement.classList.contains("size-filter-applied"))) {
                const allProducts = document.querySelectorAll('#product-grid li.column:not(.promotion-column)');
                if (allProducts.length > 0) {
                    FacetFiltersForm.originalTotalCount = allProducts.length.toString();
                }
            }
            
            if (sectionElement && sectionElement.classList.contains("size-filter-applied")) {
                const allProducts = document.querySelectorAll('#product-grid li.column:not(.promotion-column)');
                const visibleProducts = Array.from(allProducts).filter(product => product.offsetParent !== null);
                
                if (visibleProducts.length > 0 && allProducts.length !== visibleProducts.length && FacetFiltersForm.originalTotalCount) {
                    countHTML = countHTML.replace(/\d+(?:\s+of\s+\d+)?/, visibleProducts.length + " of " + FacetFiltersForm.originalTotalCount);
                }
            }
            
            for (var o of r) (o.innerHTML = countHTML), o.classList.remove("loading");
        }
    }
    static updateProductCount() {
        const sectionElement = document.querySelector('.new-collection-section');
        if (!sectionElement || !sectionElement.classList.contains("size-filter-applied") || !FacetFiltersForm.originalTotalCount) {
            return;
        }
        
        const countElements = document.getElementsByClassName("thb-filter-count");
        const mobileCountElements = document.getElementsByClassName("mobile-filter-count");
        
        if (countElements.length === 0 && mobileCountElements.length === 0) {
            return;
        }
        
        const allProducts = document.querySelectorAll('#product-grid li.column:not(.promotion-column)');
        const visibleProducts = Array.from(allProducts).filter(product => product.offsetParent !== null);
        
        if (visibleProducts.length > 0 && allProducts.length !== visibleProducts.length) {
            let updatedHTML;
            
            if (countElements.length > 0) {
                const currentHTML = countElements[0].innerHTML;
                updatedHTML = currentHTML.replace(/\d+(?:\s+of\s+\d+)?/, visibleProducts.length + " of " + FacetFiltersForm.originalTotalCount);
            } else if (mobileCountElements.length > 0) {
                const currentHTML = mobileCountElements[0].innerHTML;
                updatedHTML = currentHTML.replace(/\d+(?:\s+of\s+\d+)?/, visibleProducts.length + " of " + FacetFiltersForm.originalTotalCount);
            }
            
            if (updatedHTML) {
                for (var o of countElements) {
                    o.innerHTML = updatedHTML;
                }
                for (var o of mobileCountElements) {
                    o.innerHTML = updatedHTML;
                }
            }
        }
    }
    static renderFilters(e, t) {
        const r = new DOMParser().parseFromString(e, "text/html"),
            o = r.querySelectorAll("#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row"),
            c = (e) => {
                const r = t ? t.target.closest("collapsible-row") : void 0;
                return !!r && e.dataset.index === r.dataset.index;
            },
            n = Array.from(o).filter((e) => !c(e)),
            i = Array.from(o).find(c);
        n.forEach((e) => {
            document.querySelector(`collapsible-row[data-index="${e.dataset.index}"]`).innerHTML = e.innerHTML;
        }),
            FacetFiltersForm.renderActiveFacets(r),
            FacetFiltersForm.renderAdditionalElements(r),
            new FacetsToggle(),
            i && FacetFiltersForm.renderCounts(i, t.target.closest("collapsible-row"));
    }
    static renderActiveFacets(e) {
        [".active-facets"].forEach((t) => {
            const r = e.querySelector(t);
            r && (document.querySelector(t).innerHTML = r.innerHTML);
        }),
            FacetFiltersForm.toggleActiveFacets(!1);
    }
    static renderAdditionalElements(e) {
        [".mobile-filter-count"].forEach((t) => {
            const serverElement = e.querySelector(t);
            if (serverElement) {
                const sectionElement = document.querySelector('.new-collection-section');
                let countHTML = serverElement.innerHTML;
                
                if (!FacetFiltersForm.originalTotalCount && (!sectionElement || !sectionElement.classList.contains("size-filter-applied"))) {
                    const allProducts = document.querySelectorAll('#product-grid li.column:not(.promotion-column)');
                    if (allProducts.length > 0) {
                        FacetFiltersForm.originalTotalCount = allProducts.length.toString();
                    }
                }
                
                if (sectionElement && sectionElement.classList.contains("size-filter-applied")) {
                    const allProducts = document.querySelectorAll('#product-grid li.column:not(.promotion-column)');
                    const visibleProducts = Array.from(allProducts).filter(product => product.offsetParent !== null);
                    
                    if (visibleProducts.length > 0 && allProducts.length !== visibleProducts.length && FacetFiltersForm.originalTotalCount) {
                        countHTML = countHTML.replace(/\d+(?:\s+of\s+\d+)?/, visibleProducts.length + " of " + FacetFiltersForm.originalTotalCount);
                    }
                }
                
                const targetElement = document.querySelector(t);
                if (targetElement) {
                    targetElement.innerHTML = countHTML;
                }
            }
        });
    }
    static renderCounts(e, t) {
        const r = t.querySelector(".facets__selected");
        e.querySelector(".facets__selected") && r && (t.querySelector(".facets__selected").outerHTML = e.querySelector(".facets__selected").outerHTML);
    }
    static updateURLHash(e) {
        history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
    }
    static getSections() {
        return [{ section: document.getElementById("product-grid").dataset.id }];
    }
    onSubmitHandler(e) {
      e.preventDefault();
      const formData = new FormData(e.target.closest("form"));
      const searchParams = new URLSearchParams(formData);
    
      // Remove default price filters if present
      if (searchParams.get("filter.v.price.gte") === "0.00") {
        searchParams.delete("filter.v.price.gte");
      }
      const priceSlider = document.querySelector(".price_slider");
      if (
        priceSlider &&
        searchParams.get("filter.v.price.lte") ===
          parseFloat(priceSlider.dataset.max).toFixed(2)
      ) {
        searchParams.delete("filter.v.price.lte");
      }
      // Determine if only 'filter.v.availability' is being applied
      const appliedFilters = Array.from(searchParams.keys()).filter((key) =>
        key.startsWith("filter.")
      );
      const isOnlyAvailabilityFilter =
        appliedFilters.length === 1 && appliedFilters[0] === "filter.v.availability";
    
      // Set a flag to control scroll behavior
      window.skipScrollToTop = isOnlyAvailabilityFilter;

      if(searchParams.has("filter.v.option.size")){
        searchParams.set("filter.v.availability", 1);
        this.sectionElement.classList.add("size-filter-applied");
      } else {
        this.sectionElement.classList.remove("size-filter-applied");
      }
    
      FacetFiltersForm.renderPage(searchParams.toString(), e);
    }

    onActiveFilterClick(e) {
        e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
        const t = -1 == e.currentTarget.href.indexOf("?") ? "" : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
        
        if(t) {
          const searchParams = new URLSearchParams(t);
          if(searchParams.has("filter.v.option.size")){
            this.sectionElement.classList.add("size-filter-applied");
          } else {
            this.sectionElement.classList.remove("size-filter-applied");
          }
        } else {
          this.sectionElement.classList.remove("size-filter-applied");
        }
        
        FacetFiltersForm.renderPage(t);
    }
}
(FacetFiltersForm.filterData = []),
    (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
    (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
    (FacetFiltersForm.originalTotalCount = null),
    customElements.define("facet-filters-form", FacetFiltersForm),
    FacetFiltersForm.setListeners();
class FacetRemove extends HTMLElement {
    constructor() {
        super(),
            this.querySelectorAll("a").forEach((e) => {
                e.addEventListener("click", (e) => {
                    e.preventDefault();
                    (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e);
                });
            });
    }
}
customElements.define("facet-remove", FacetRemove);
class PriceSlider extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        let e = this.querySelector(".price_slider"),
            t = this.querySelector(".price_slider_amount"),
            r = { start: [parseFloat(e.dataset.minValue || 0), parseFloat(e.dataset.maxValue || e.dataset.max)], connect: !0, step: 10, direction: document.dir, range: { min: 0, max: parseFloat(e.dataset.max) } },
            o = new CustomEvent("input"),
            c = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
        e.classList.contains("noUi-target") && e.noUiSlider.destroy(),
            noUiSlider.create(e, r),
            e.noUiSlider.on("update", function (e) {
                (t.querySelector(".field__input_min").value = e[0]), (t.querySelector(".field__input_max").value = e[1]);
            }),
            e.noUiSlider.on("change", function (e) {
                c.querySelector("form").dispatchEvent(o);
            });
    }
}
customElements.define("price-slider", PriceSlider),
    window.addEventListener("load", () => {
        new FacetsToggle();
    });
